import {
  getCurrentAccount,
  useCurrentAccount,
} from '@/store/use-account-store';
import { COLLATERAL_DECIMALS, useMarketStore } from '@/store/use-markets-store';
import { abbrFromSym } from '@/utils/token-symbol';
import {
  bigIntToDecimalStr,
  bigIntToNum,
  formatNumber,
} from '@/utils/value-format';
import { useStore } from 'zustand';

type Props = {
  symbol: string;
};

export default function Value({ symbol }: Props) {
  const value = useCurrentAccount(
    (state) => state.positions[symbol].value.decimal,
  );
  const size = useCurrentAccount((state) => state.positions[symbol].size);
  const sizeDecimals = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.sizeDecimals,
  );

  return (
    <div>
      <div>
        {formatNumber(value, { digits: 2, style: 'currency', round: 'ceil' })}
      </div>
      <div className="text-base text-muted-foreground">
        {bigIntToDecimalStr(size, sizeDecimals)} {abbrFromSym(symbol)}
      </div>
    </div>
  );
}

export const valueAccessorFn = (symbol: string) => {
  const { value } = getCurrentAccount((state) => state.positions[symbol]);
  return bigIntToNum(value.bigint, COLLATERAL_DECIMALS);
};
